import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoginPageComponent} from './login-page/login-page.component';
import {NotFoundPageComponent} from './not-found-page/not-found-page.component';
import {DefaultComponent} from './default/default.component';
import {LandingComponent} from './landing/landing.component';
import {RouterModule} from '@angular/router';
import {PortalModule} from '@angular/cdk/portal';
import {CoreModule} from '../core/core.module';
import {ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '../shared/shared.module';
import {AffixHeaderDirective} from './default/affix-header.directive';
import {NzLayoutModule} from 'ng-zorro-antd/layout';
import {NzIconModule} from 'ng-zorro-antd/icon';
import {NzAvatarModule} from 'ng-zorro-antd/avatar';
import {NzMenuModule} from 'ng-zorro-antd/menu';
import {NzAffixModule} from 'ng-zorro-antd/affix';
import {NzCardModule} from 'ng-zorro-antd/card';
import {NzGridModule} from 'ng-zorro-antd/grid';
import {NzDividerModule} from 'ng-zorro-antd/divider';
import {NzFormModule} from 'ng-zorro-antd/form';
import {NzInputModule} from 'ng-zorro-antd/input';
import {NzButtonModule} from 'ng-zorro-antd/button';

@NgModule({
  declarations: [LoginPageComponent, NotFoundPageComponent, DefaultComponent,
    LandingComponent, AffixHeaderDirective],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    PortalModule,
    CoreModule,
    SharedModule,
    NzLayoutModule,
    NzIconModule,
    NzAvatarModule,
    NzMenuModule,
    NzAffixModule,
    NzCardModule,
    NzGridModule,
    NzDividerModule,
    NzFormModule,
    NzInputModule,
    NzButtonModule,
  ],
  exports: [
    LoginPageComponent, NotFoundPageComponent, DefaultComponent, LandingComponent, AffixHeaderDirective
  ]
})
export class LayoutModule {
}
